import React from 'react';
import StarRating from './StarRating';
import './Reviews.css';

const ReviewCard = ({ review }) => (
    <div className='reviewCard'>
        <div className='reviewCardHeader'>
            <div className='reviewMeta'>
                <strong className='reviewAuthor'>{review.userName}</strong>
                <span className='reviewDate'>
                    {new Date(review.createdAt).toLocaleDateString('en-GB', {
                        day: 'numeric', month: 'short', year: 'numeric'
                    })}
                </span>
            </div>
            <StarRating value={review.rating} readOnly size="small" />
        </div>
        <p className='reviewComment'>{review.comment}</p>
    </div>
);

export default ReviewCard;
